import { metrics } from "lib/metrics";
import { useMemo } from "react";
import useSWR from "swr";
import { FastMarketInfoData } from "..";

import { fetchV2Markets } from "lib/indexer/client";

export function useFastMarketsInfoRequest(chainId: number) {
  const {
    data: fastMarketInfoData,
    error,
    isLoading,
  } = useSWR<FastMarketInfoData | undefined>([chainId, "useFastMarketsInfoRequest"], {
    refreshInterval: undefined,
    fetcher: async () => {
      try {
        const res = await fetchV2Markets();
        if (!res.markets || res.markets.length === 0) {
          return undefined;
        }

        return res.markets.reduce((acc: FastMarketInfoData, mInfo) => {
          acc[mInfo.marketTokenAddress] = mInfo;
          return acc;
        }, {} as FastMarketInfoData);
      } catch (e) {
        metrics.pushError(e, "useFastMarketsInfoRequest");
        throw e;
      }
    },
  });

  return useMemo(
    () => ({
      fastMarketInfoData,
      error,
      isLoading,
    }),
    [error, fastMarketInfoData, isLoading]
  );
}
